import * as Yup from "yup";

export const claimMasterValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company Code is required"),
  description: Yup.string().required("Claim Name is required"),
  isActive: Yup.bool(),
});

export const addClaimValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company Code is required"),
  employeeCode: Yup.string().required("Employee Code is required"),
  claimType: Yup.string().required("Claim Type is required"),
  description: Yup.string(),
  transactionId: Yup.string(),
  fromDate: Yup.string(),
  toDate: Yup.string(),
  remarks: Yup.string(),
  claimAmount: Yup.number().required("claim Amount is required"),
  isActive: Yup.bool().required("isActive is required"),
  isApproval: Yup.bool().required("isApproval is required"),
});

export const claimDataValidation = Yup.object().shape({
  claimData: Yup.array().of(
    Yup.object().shape({
      companyCode: Yup.number().required("Company Code is required"),
      code: Yup.number(), //.required("Code is required"),
      employeeCode: Yup.string().required("Employee Code is required"),
      description: Yup.string().required("Description is required"),
      claimAmount: Yup.number().required("Claim Amount is required"),
      claimType: Yup.string().required("Claim Type is required"),
      isApproval: Yup.number().required("isApproval is required"),
      transactionId: Yup.string().required("Transaction ID is required"),
      fromDate: Yup.string().required("From Date is required"),
      toDate: Yup.string().required("To Date is required"),
      remarks: Yup.string().required("Remarks are required"),
      createUser: Yup.string().required("Create User is required"),
      createDate: Yup.string().required("Create Date is required"),
      modifyUser: Yup.string().required("Modify User is required"),
      modifyDate: Yup.string().required("Modify Date is required"),
      isActive: Yup.bool().required("isActive is required"),
      locationCode: Yup.string().required("Location Code is required"),
      claimAttachments: Yup.array().of(
        Yup.object().shape({
          slNo: Yup.number().required("Sl No is required"),
          companyCode: Yup.number().required("Company Code is required"),
          code: Yup.number().required("Code is required"),
          employeeCode: Yup.string().required("Employee Code is required"),
          attachment: Yup.string().required("Attachment is required"),
          createUser: Yup.string().required("Create User is required"),
          createDate: Yup.string().required("Create Date is required"),
          modifyUser: Yup.string().required("Modify User is required"),
          modifyDate: Yup.string().required("Modify Date is required"),
          isActive: Yup.bool().required("isActive is required"),
        })
      ),
    })
  ),
});

// export const claimDataValidation = Yup.object().shape({
//   claimData: Yup.array().of(
//     Yup.object().shape({
//       companyCode: Yup.number().min(1).required("Company Code is required"),
//       employeeCode: Yup.string().required("Employee Code is required"),
//       claimType: Yup.string().required("Claim Type is required"),
//       description: Yup.string().required("Description is required"),
//       transactionId: Yup.string(),
//       fromDate: Yup.string().required("from date is required"),
//       toDate: Yup.string().required("from date is required"),
//       remarks: Yup.string(),
//       claimAmount: Yup.number().required("claim Amount is required"),
//       isActive: Yup.bool().required("isActive is required"),
//       isApproval: Yup.bool().required("isApproval is required"),
//       attachment : Yup.string().nullable(),
//     })
//   ),
// });
